<template>
  <section v-if="items.length || error" class="approval-notifications" aria-label="Revisiones aprobadas">
    <div class="approval-notifications__head">
      <h3>Revisiones aprobadas</h3>
      <button v-if="items.length" type="button" :disabled="clearing" aria-label="Limpiar notificaciones de revisiones aprobadas" @click="$emit('clear')">{{ clearing ? 'Limpiando…' : 'Limpiar' }}</button>
    </div>
    <p v-if="error" role="alert">{{ error }}</p>
    <article v-for="item in items" :key="item.id" class="approval-notifications__item">
      <span class="approval-notifications__icon" aria-hidden="true"><i class="fas fa-check-circle"></i></span>
      <div class="approval-notifications__copy">
        <p class="approval-notifications__title">Ficha aprobada</p>
        <p>{{ item.company_name }} · Versión {{ item.version }}</p>
        <time :datetime="item.created_at">{{ formatDateTime(item.created_at) }}</time>
        <p class="approval-notifications__hint">Informativo · No requiere acción</p>
        <router-link :to="{ name: 'CompanyShow', params: { id: String(item.company_id) } }" @click.native="$emit('navigate')">Ir al cliente <span aria-hidden="true">→</span></router-link>
      </div>
    </article>
  </section>
</template>

<script>
import { formatDateTime } from '@/utils/date'

export default {
  props: { items: { type: Array, default: () => [] }, error: { type: String, default: '' }, clearing: { type: Boolean, default: false } },
  methods: { formatDateTime }
}
</script>

<style scoped>
.approval-notifications { max-height: 20rem; overflow-y: auto; padding: 0.85rem; border-bottom: 1px solid #e6ded2; }
.approval-notifications__head { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.65rem; }
.approval-notifications h3 { margin: 0; font-size: 0.85rem; font-weight: 700; color: #352b21; }
.approval-notifications__head button { padding: 0.3rem 0.65rem; border: 1px solid #ddd2c4; border-radius: 999px; background: #fffaf3; color: #62513b; font: inherit; font-size: 0.75rem; cursor: pointer; }
.approval-notifications__head button:disabled { opacity: 0.6; cursor: wait; }
.approval-notifications__head button:focus-visible { outline: 2px solid #93724a; outline-offset: 3px; }
.approval-notifications__item { display: flex; align-items: flex-start; gap: 0.65rem; padding: 0.75rem 0; }
.approval-notifications__item + .approval-notifications__item { border-top: 1px solid #eee7dd; }
.approval-notifications__icon { color: #3b6549; padding-top: 0.1rem; }
.approval-notifications__copy { min-width: 0; overflow-wrap: anywhere; }
.approval-notifications p { margin: 0; font-size: 0.78rem; line-height: 1.5; color: #62584c; }
.approval-notifications .approval-notifications__title { color: #352b21; font-weight: 700; font-size: 0.85rem; }
.approval-notifications time, .approval-notifications .approval-notifications__hint { font-size: 0.7rem; color: #776b5d; }
.approval-notifications a { display: inline-block; margin-top: 0.4rem; padding: 0.2rem 0; color: #766043; font-size: 0.75rem; text-decoration: underline; text-underline-offset: 3px; }
.approval-notifications a:focus-visible { outline: 2px solid #93724a; outline-offset: 3px; }
</style>
